import {connect} from 'react-redux';
import {Navigate} from 'react-router-dom';

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

export const PrivateRoutes = ({
  children,
  user: {isAuthenticated},
}) => {
  if (!isAuthenticated) return <Navigate to="/login" />;
  return <>{children}</>;
};

export default connect(mapStateToProps, null)(PrivateRoutes);
